import { useEffect, useRef, useState } from 'react'
import lottie from 'lottie-web/build/player/lottie_svg'

export default function LottieSvg({ lottieUrl, className = '', lazy = true }) {
  const rootRef = useRef(null)
  const containerRef = useRef(null)
  const [visible, setVisible] = useState(!lazy)

  useEffect(() => {
    if (!lazy || visible || !rootRef.current) return undefined

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true)
          observer.disconnect()
        }
      },
      { rootMargin: '120px', threshold: 0.01 },
    )

    observer.observe(rootRef.current)
    return () => observer.disconnect()
  }, [lazy, visible])

  useEffect(() => {
    if (!visible || !containerRef.current || !lottieUrl) return undefined

    let animation = null
    let cancelled = false

    fetch(lottieUrl)
      .then((response) => response.json())
      .then((data) => {
        if (cancelled || !containerRef.current) return

        const animationData = { ...data }
        delete animationData.tgs

        animation = lottie.loadAnimation({
          container: containerRef.current,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          rendererSettings: { preserveAspectRatio: 'xMidYMid meet' },
          animationData,
        })
      })
      .catch((err) => console.error('[LottieSvg] load failed', err))

    return () => {
      cancelled = true
      try {
        animation?.destroy()
      } catch (error) {
        if (error?.name !== 'NotFoundError') throw error
      }
    }
  }, [visible, lottieUrl])

  return (
    <div
      ref={rootRef}
      className={`flex items-center justify-center ${className}`}
      aria-hidden="true"
    >
      <div ref={containerRef} className="h-full w-full" />
    </div>
  )
}
